// extracted by mini-css-extract-plugin
module.exports = {"employerFormsContainer":"styles_employerFormsContainer__37Z2h","employerFormsFrame":"styles_employerFormsFrame__4CoyT","mainContainer":"styles_mainContainer__3NtdS"};